import React from "react";

const Test = () => {
  return <h1>Testing Route</h1>;
};

export default Test;
